export const parseHostForSDK = (host) => {
  if (!host) {
    throw new Error(
      "REACT_APP_TINODE_HOST is required. Please set it in your .env file (e.g., REACT_APP_TINODE_HOST=example.com:6060 or REACT_APP_TINODE_HOST=wss://example.com)",
    );
  }

  const hostRaw = String(host).trim();

  const isSecure =
    hostRaw.toLowerCase().startsWith("wss://") ||
    hostRaw.toLowerCase().includes("https://");

  let cleanHost = hostRaw;

  cleanHost = cleanHost
    .replace(/^(wss?|https?):\/\/+/gi, "")
    .replace(/^ws\/\/+/gi, "")
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");

  if (cleanHost.startsWith("ws/") || cleanHost.startsWith("ws://")) {
    cleanHost = cleanHost.replace(/^ws\/?\/?/, "");
  }

  if (!cleanHost || cleanHost === "ws" || cleanHost.startsWith("ws/")) {
    throw new Error(
      `Invalid REACT_APP_TINODE_HOST: "${host}". Expected format: hostname:port or wss://hostname or ws://hostname`,
    );
  }

  const portMatch = cleanHost.match(/^([a-zA-Z0-9.\-]+):(\d+)/);
  if (portMatch) {
    cleanHost = `${portMatch[1]}:${portMatch[2]}`;
  } else {
    const hostnameMatch = cleanHost.match(/^([a-zA-Z0-9.\-]+)/);
    if (hostnameMatch) {
      const defaultPort = isSecure ? 443 : 6060;
      cleanHost = `${hostnameMatch[1]}:${defaultPort}`;
    } else {
      throw new Error(
        `Invalid REACT_APP_TINODE_HOST: "${host}". Could not extract hostname`,
      );
    }
  }

  if (
    cleanHost.includes("://") ||
    cleanHost.includes("/") ||
    cleanHost.includes("ws")
  ) {
    throw new Error(
      `Invalid REACT_APP_TINODE_HOST: "${host}". Host contains invalid characters. Expected format: hostname:port or wss://hostname`,
    );
  }

  if (!cleanHost.match(/^[a-zA-Z0-9.\-]+:\d+$/)) {
    throw new Error(
      `Invalid REACT_APP_TINODE_HOST: "${host}". Expected format: hostname:port or wss://hostname or ws://hostname`,
    );
  }

  return cleanHost;
};

export const shouldUseSecureConnection = (hostRaw) => {
  if (
    hostRaw &&
    (hostRaw.startsWith("wss://") || hostRaw.includes("https://"))
  ) {
    return true;
  }

  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.protocol === "https:"
  ) {
    return true;
  }

  return false;
};
